import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { Loader, Message } from "semantic-ui-react";
import type { Settlement } from "../../../redux/modules/settlement";
import {
  fetchSettlements,
  settlementManager,
  sortBySettleDate,
} from "../../../redux/modules/settlement";
import { ErrorWrap } from "../../../helpers/error";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { SettlementTable } from "./settlement-table";
import { sliceList } from "../../../helpers/filter";
import { Pagination } from "../../../components/common/pagination";
import { Link } from "react-router-dom";
import { t } from "../../../constant/translations";

type Props = {
  settlement: ?Array<Settlement>,
  error: Object,
  loading: boolean,
  fetchSettlements: (args: Object) => any,
  clearError: () => any,
};

const PaginationWrapper = styled.div`
  margin: 1em 0;
`;

const SettlementListEstateComponent = (props: Props) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(5);

  useEffect(() => {
    props.fetchSettlements({
      estate: props.estate.id,
      page_size: 1000,
    });
  }, []);

  useEffect(() => {
    if (props.estate) {
      props.fetchSettlements({ estate: props.estate.id });
    }
  }, [props.estate]);

  const { settlements, loading, error, clearError } = props;

  if (loading || !settlements) {
    return <Loader active={true} />;
  }

  let page = [];
  if (settlements.length > 0) {
    page = sliceList(settlements, currentPage - 1, pageSize);
  }

  return (
    <div>
      {error.exists() && (
        <Message
          error
          content={error.getGlobal()}
          onDismiss={() => clearError()}
        />
      )}
      <PaginationWrapper>
        <Pagination
          current={currentPage}
          total={settlements.length}
          onChange={(newPage, newPageSize) => {
            setCurrentPage(newPage);
            setPageSize(newPageSize);
          }}
          pageSize={pageSize}
        />
        <Link
          to={`/ui/block/${props.estate.block.id}/billing/settlements/?estate_vendor_id=${props.estate.vendor_id}`}
          style={{ float: "right" }}
        >
          {t("labels.toall")}
        </Link>
      </PaginationWrapper>
      <div>
        <SettlementTable settlements={page} estateLink={false} />
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    settlements: sortBySettleDate(state.settlement.entities),
    loading: state.settlement.pending,
    error: ErrorWrap.fromError(state.settlement.error),
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      fetchSettlements,
      clearError: settlementManager.actions.clearError,
    },
    dispatch
  );
};

export const SettlementListEstate = connect(
  mapStateToProps,
  mapDispatchToProps
)(SettlementListEstateComponent);
